import ConnectionEditPageContainer from './containers/ConnectionEditPageContainer'

export default ConnectionEditPageContainer
